import { createBrowserRouter, RouterProvider } from "react-router-dom";

import { ErrorBoundary } from "../components/ErrorBoundary";
import { RouteError } from "../components/RouteError";
import BaseLayout from "../layouts/BaseLayout";
import Dashboard from "../pages/dashboard";
import PrivacyPolicy from "../pages/PrivacyPolicy/PrivacyPolicy";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <ErrorBoundary>
        <BaseLayout />
      </ErrorBoundary>
    ),

    errorElement: <RouteError />,

    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "privacy",
        element: <PrivacyPolicy />,
      },
    ],
  },
]);

export function Router() {
  return <RouterProvider router={router} />;
}

export default Router;
